<template>
    <div>
        <div
            v-if="editor"
            class="bg-white border-2 border-blue rounded-md px-3 pt-2"
            style="min-height: 200px;"
            :class="{ 'border-blue-600': editorFocused }"
            v-bind="$attrs">
            <div class="menubar mb-2">
                <button
                    class="px-2 py-1 bg-blue text-sm text-gray"
                    :class="{ 'is-active': editor.isActive('bold') }"
                    @click="editor.chain().focus().toggleBold().run()">
                    <i class="fas fa-bold"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    :class="{ 'is-active': editor.isActive('italic') }"
                    @click="editor.chain().focus().toggleItalic().run()">
                    <i class="fas fa-italic"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    :class="{ 'is-active': editor.isActive('strike') }"
                    @click="editor.chain().focus().toggleStrike().run()">
                    <i class="fas fa-strikethrough"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    :class="{ 'is-active': editor.isActive('underline') }"
                    @click="editor.chain().focus().toggleUnderline().run()">
                    <i class="fas fa-underline"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    :class="{ 'is-active': editor.isActive('hardBreak') }"
                    @click="editor.chain().focus().setHardBreak().run()">
                    <i class="fas fa-level-down-alt fa-rotate-90"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    :class="{ 'is-active': editor.isActive('bulletList') }"
                    @click="editor.chain().focus().toggleBulletList().run()">
                    <i class="fas fa-list-ul"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    :class="{ 'is-active': editor.isActive('orderedList') }"
                    @click="editor.chain().focus().toggleOrderedList().run()">
                    <i class="fas fa-list-ol"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    @click="editor.chain().focus().undo().run()">
                    <i class="fas fa-undo"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    @click="editor.chain().focus().redo().run()">
                    <i class="fas fa-redo"></i>
                </button>

                <button
                    class="px-2 py-1 bg-blue text-sm text-gray ml-1"
                    @click="editor.chain().focus().clearNodes().unsetAllMarks().run()">
                    <i class="fa-solid fa-text-slash"></i>
                </button>
            </div>
            <editor-content :editor="editor" />
        </div>
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import HardBreak from '@tiptap/extension-hard-break';
import BulletList from '@tiptap/extension-bullet-list';
import ListItem from '@tiptap/extension-list-item';

export default {
    props: {
        modelValue: {
            type: String,
            default: '',
        },
    },
    components: {
        EditorContent
    },
    data() {
        return {
            editor: null,
            editorFocused: false,
        }
    },
    watch: {
        modelValue(value) {
            const isSame = this.editor.getHTML() === value;

            if (isSame) {
                return;
            }

            this.editor.commands.setContent(this.modelValue, false);
        },
    },
    mounted () {
        this.editor = new Editor({
            content: this.modelValue,
            extensions: [
                StarterKit,
                Underline,
                BulletList,
                ListItem,
            ],
            onUpdate: () => {
                this.$emit('updated', this.editor.getHTML());
            },
            onBlur: () => {
                this.editorFocused = false;
            },
            onFocus: () => {
                this.editorFocused = true;
            }
        })
    },
    beforeUnmount() {
        this.editor.destroy()
    },
}
</script>
